import { mergeStyleSets } from '@uifabric/styling';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  option: {
    fontWeight: 400,
    textAlign: 'left',
  },
  optionHighlighted: {
    backgroundColor: theme.palette.neutralLighter,
  },
  errorMessage: {
    borderColor: theme.palette.accentError,
    color: theme.palette.accentError,
    fontWeight: 400,
    fontSize: pxToRem(12),
    paddingTop: pxToRem(5),
  },
});
